import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { colors } from "@mui/material";
import { decryptData } from "../../../../crypto";

function QuestionPaper({ questions, withAnswers }) {
  const [isUnacademy, setIsUnacademy] = useState(false);

  useEffect(() => {
    const encryptedEmail = sessionStorage.getItem("email");
    const decryptedEmail = decryptData(encryptedEmail) || "";
    const userEmail = decryptedEmail.toString().toLowerCase();

    setIsUnacademy(userEmail.includes("unacademy@gmail.com"));
  }, []);

  function sortAlphabetArray(arr) {
    return [...new Set(arr.map((a) => a.toString()))].sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base" }),
    );
  }

  return (
    <Box className="question-paper-container">
      <style>{`
        .question-paper-container img {
          max-width: 100% !important;
          height: auto !important;
          vertical-align: middle !important;
          display: inline-block !important;
          image-rendering: -webkit-optimize-contrast;
        }
      `}</style>
      {questions.map((question, qIndex) => (
        <Box
          sx={{ width: "100%", padding: 2, borderBottom: "1px solid #ccc" }}
          key={qIndex}
          mb={3}
        >
          {/* Question */}
          <p
            style={{ fontWeight: "bold", color: "black", marginBottom: "10px" }}
          >
            Question No. {qIndex + 1} / {isUnacademy ? `Question UID : ${question.question_uid || question.id}` : `Question ID : ${question.id}`}
          </p>
          <Box
            // sx={{
            //   "& img": {
            //     width: "80%",
            //     objectFit: "contain",
            //   },
            // }}
            dangerouslySetInnerHTML={{ __html: question.question_en }}
            mb={1}
          />
          <Box
            style={{
              color: "black",
              display: "flex",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <div>
              Question Type: {question.question_type === "Range" ?
                "Fill In The Blanks" : question.question_type
              };
              {/* <span style={{ fontWeight: "bold", color: "black" }}>
                {question.question_type !== "Fill In The Blanks"
                  ? "MCQ"
                  : question.question_type}
                ;
              </span> */}
            </div>
            <div>
              Marks for correct answer:{" "}
              <span
                style={{ fontWeight: "bold", color: "green" }}
              >
                {question.mark};
              </span>
            </div>
            <div>
              Negative marks:{" "}
              <span
                style={{ fontWeight: "bold", color: "red" }}
              >
                {question.negative_mark}
              </span>
            </div>
          </Box>
          {/* Options */}
          {question.question_type !== "Fill In The Blanks" && question.question_type !== "Range" && (
            <Box display="flex" flexDirection="column" gap={1}>
              {question.options.map((option, oIndex) => (
                <Box
                  key={oIndex}
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{
                    "& img": {
                      // width: "100px",
                      // height: "50px",
                      objectFit: "contain",
                    },
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    {isUnacademy
                      ? `${String.fromCharCode(65 + oIndex)} / Response UID : ${option.response_uid || option.id} :`
                      : `${String.fromCharCode(65 + oIndex)}`}
                  </span>{" "}
                  <Box dangerouslySetInnerHTML={{ __html: option.option_en }} />
                  {question.question_type.includes("Match") && (
                    <>
                      {" -> "}
                      {sortAlphabetArray(
                        question.options.flatMap((option) =>
                          (option.solution_en || "")
                            .split(",")
                            .map((o) => o.trim()),
                        ),
                      ).map((item, index) => (
                        <span key={index}>{item}</span>
                      ))}
                    </>
                  )}
                </Box>
              ))}
            </Box>
          )}
          {withAnswers && (
            <div>
              {question.question_type !== "Fill In The Blanks" && question.question_type !== "Range" ? (
                <Box display="flex" flexDirection="column" gap={1}>
                  <span
                    style={{ fontWeight: "bold", color: "black" }}
                  >{`Correct Answer`}</span>{" "}
                  {question.options.map(
                    (option, oIndex) =>
                      option.correct_option && (
                        <React.Fragment key={oIndex}>
                          <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              paddingBottom: 1,
                            }}
                          >
                            <span
                              style={{ fontWeight: "bold", color: "black" }}
                            >
                              {isUnacademy
                                ? `${String.fromCharCode(65 + oIndex)} / Response UID : ${option.response_uid || option.id} :`
                                : `${String.fromCharCode(65 + oIndex)}`}
                            </span>{" "}
                            <Box
                              dangerouslySetInnerHTML={{
                                __html: option.option_en,
                              }}
                            />
                            {question.question_type.includes("Match") && (
                              <>
                                {" -> "}
                                {sortAlphabetArray(
                                  question.options[oIndex].solution_en.split(', ')
                                ).map((item, index) => (
                                  <span key={index}>{item}</span>
                                ))}
                              </>
                            )}
                          </Box>
                        </React.Fragment>
                      ),
                  )}
                </Box>
              ) : (
                <Box style={{ fontWeight: "bold", color: "black" }}>
                  <span
                    style={{ fontWeight: "bold", color: "black" }}
                  >{`Correct Answer`}</span>{" "}
                  {question.options[0].solution_en}
                </Box>
              )}
            </div>
          )}
        </Box>
      ))}
    </Box>
  );
}
export default QuestionPaper;
